import React, { useState, Fragment } from 'react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

export function Checkbox({
  children,
  name,
  alignment,
  textClasses,
  value,
  defaultChecked,
  onChange,
  disabled,
}) {
  return (
    <div className={clsx('form-control', alignment == 'start' && 'self-start')}>
      <label className="cursor-pointer label justify-start">
        <input
          type="checkbox"
          defaultChecked={defaultChecked ?? true}
          className={clsx(
            'checkbox checkbox-secondary border-2',
            disabled && 'checkbox-disabled',
          )}
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
        />
        <span className={twMerge('label-text ml-2 text-white', textClasses)}>
          {children}
        </span>
      </label>
    </div>
  );
}

export function CheckboxArea({
  values,
  defaultValues,
  checkboxFormName,
  minSelected,
}) {
  const [selectedCheckboxes, setSelectedCheckboxes] = useState(
    defaultValues.map(({ value }) => value),
  );
  const maxLabelLength = Math.max(...values.map(({ label }) => label.length));
  const isCheckedByDefault = (value) => {
    return defaultValues?.map(({ value }) => value)?.includes(value);
  };

  return (
    <div
      className={clsx(
        'grid',
        maxLabelLength > 7 ? 'grid-cols-1' : 'grid-cols-2',
      )}
    >
      {values?.map(({ value, label }) => {
        const isDisabled =
          selectedCheckboxes.includes(value) &&
          selectedCheckboxes.length === minSelected;
        return (
          <Fragment key={value}>
            <Checkbox
              name={checkboxFormName}
              value={value}
              defaultChecked={isCheckedByDefault(value)}
              onChange={(event) =>
                setSelectedCheckboxes((p) => {
                  let newVal = [...p];
                  if (event.target.checked) {
                    newVal.push(value);
                  } else {
                    newVal = newVal.filter((checkbox) => checkbox !== value);
                  }
                  return newVal;
                })
              }
              disabled={isDisabled}
            >
              {label}
            </Checkbox>
            {/* to send also disabled checkboxes */}
            {isDisabled && (
              <input type="hidden" name={checkboxFormName} value={value} />
            )}
          </Fragment>
        );
      })}
    </div>
  );
}

export function RadioBtn({ defaultChecked, label, onSelect, name, value }) {
  return (
    <div className="form-control">
      <label className="label cursor-pointer">
        <input
          type="radio"
          name={name}
          className="radio ml-0"
          defaultChecked={defaultChecked}
          onChange={onSelect}
          value={value}
        />
        <span className="label-text text-lg ml-2">{label}</span>
      </label>
    </div>
  );
}

export function DateRange({ defaults, limits, name, label }) {
  const addDaysToDate = (date, days) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate.toISOString().split('T')[0];
  };

  const [dynamicLimits, setDynamicLimits] = useState({
    fromMax: addDaysToDate(defaults.max, -1),
    toMin: addDaysToDate(defaults.min, 1),
  });

  return (
    <>
      <div className="flex items-center justify-between gap-3">
        <input
          type="date"
          className="input input-sm"
          name={name}
          defaultValue={defaults.min}
          min={limits.min}
          max={dynamicLimits.fromMax}
          aria-label={`${label || 'Zakres dat'} - data początkowa`}
          onChange={(event) => {
            setDynamicLimits((p) => {
              return { ...p, toMin: addDaysToDate(event.target.value, 1) };
            });
          }}
        />
        -
        <input
          type="date"
          className="input input-sm"
          name={name}
          defaultValue={defaults.max}
          min={dynamicLimits.toMin}
          max={limits.max}
          aria-label={`${label || 'Zakres dat'} - data końcowa`}
          onChange={(event) => {
            setDynamicLimits((p) => {
              return { ...p, fromMax: addDaysToDate(event.target.value, -1) };
            });
          }}
        />
      </div>
    </>
  );
}
